import styled from "styled-components";
import { defaults, colors } from "../../../styles";

export const Container = styled(defaults.Container)`
  flex: 1;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
`;

export const ResponseDetail = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  &:not(:first-child) {
    border-top: 1px solid ${colors.grey};
  }

  p:first-child {
    font-weight: bold;
  }

  label {
    align-self: center;
  }

  > * {
    padding: 10px;
  }
`;

export const EditButton = styled(defaults.Button)`
  align-self: flex-end;
  background-color: "#e5e5e5";
  color: ${colors.brownishGrey};

  &:hover {
    background-color: ${colors.grey};
  }
`;
